'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { PP_STORE_DATA_KEY } from '@haaretz/s-consts';
import removeQueryParam from '@haaretz/s-navigation-utils/removeQueryParam';
import { useRouter } from 'next/router';
import React from 'react';
function actionsContextFactory() {
    const Context = /*#__PURE__*/ React.createContext(undefined);
    return function() {
        return Context;
    };
}
function dataContextFactory() {
    const Context = /*#__PURE__*/ React.createContext(undefined);
    return function() {
        return Context;
    };
}
const getPPDataStoreActionsContext = actionsContextFactory();
const getPPDataStoreContext = dataContextFactory();
const PPCouponStoreContext = /*#__PURE__*/ React.createContext(undefined);
const PPCouponUpdateStoreContext = /*#__PURE__*/ React.createContext(undefined);
export default function PPDataStoreContextProvider({ children, initialState }) {
    const [store, setStore] = React.useState(initialState || {});
    const [coupon, setCoupon] = React.useState(null);
    const storeActions = React.useMemo(()=>{
        const updateStore = (newState)=>{
            setStore((prevState)=>({
                    ...prevState,
                    ...newState
                }));
        };
        const clearStore = (field)=>setStore((prevState)=>{
                if (field) {
                    const { [field]: deleted, ...clearedState } = prevState;
                    return clearedState;
                }
                return {
                    referrer: prevState.referrer
                };
            });
        return {
            updateStore,
            clearStore
        };
    }, []);
    React.useEffect(()=>{
        const referrer = document.referrer;
        if (referrer && !store.referrer) {
            storeActions.updateStore({
                referrer
            });
        }
    }, [
        storeActions,
        store.referrer
    ]);
    const PPDataStoreContext = getPPDataStoreContext();
    const PPDataStoreActionsContext = getPPDataStoreActionsContext();
    return /*#__PURE__*/ _jsx(PPCouponStoreContext, {
        value: coupon,
        children: /*#__PURE__*/ _jsx(PPCouponUpdateStoreContext, {
            value: setCoupon,
            children: /*#__PURE__*/ _jsx(PPDataStoreContext, {
                value: store,
                children: /*#__PURE__*/ _jsx(PPDataStoreActionsContext, {
                    value: storeActions,
                    children: children
                })
            })
        })
    });
}
////////////
//  Hook  //
////////////
export function usePPDataStore() {
    const context = React.use(getPPDataStoreContext());
    if (!context) {
        throw new Error('usePPDataStore must be used within a PPDataStoreContextProvider');
    }
    return context;
}
export function usePPDataStoreActions() {
    const context = React.use(getPPDataStoreActionsContext());
    if (!context) {
        throw new Error('usePPDataStoreActions must be used within a PPDataStoreActionsContextProvider');
    }
    return context;
}
export function usePPCouponStore() {
    const context = React.use(PPCouponStoreContext);
    if (context === undefined) {
        throw new Error('usePPCouponStore must be used within a PPCouponStoreContext');
    }
    return context;
}
export function usePPUpdateCouponStore() {
    const context = React.use(PPCouponUpdateStoreContext);
    if (!context) {
        throw new Error('usePPUpdateCouponStore must be used within a PPCouponUpdateStoreContext');
    }
    return context;
}
export function usePpDataStoreInitialization() {
    const store = usePPDataStore();
    const { updateStore } = usePPDataStoreActions();
    const router = useRouter();
    React.useEffect(()=>{
        if (!store.contentId) {
            const storeDataFromUrl = router.query.storeData;
            const storeString = typeof storeDataFromUrl === 'string' ? decodeURIComponent(storeDataFromUrl) : sessionStorage.getItem(PP_STORE_DATA_KEY);
            if (storeString) {
                try {
                    const restoredStore = JSON.parse(storeString);
                    if (restoredStore) {
                        updateStore({
                            ...restoredStore
                        });
                    }
                    sessionStorage.removeItem(PP_STORE_DATA_KEY);
                    if (storeDataFromUrl) removeQueryParam('storeData', router);
                } catch (error) {
                    console.error(error.message);
                }
            }
        }
    }, [
        router,
        store,
        updateStore
    ]);
}

//# sourceMappingURL=usePPDataStore.js.map